import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { env } from '../../env';
import Select from 'react-select';
import { PrefetchSelect } from '../profile-modal/tabs/profile-tab-form';

const CredModal = ({ isOpen, onRequestClose, selectedCredId }) => {

  const [credData, setCredData] = useState({
    id: selectedCredId,
    login: '',
    password: '',
    title: '',
    proxy_id: '',
    status: 'active',
    checkStatus: false,
    proxyStatus: false,
    authStatus: false,
    checkButtonValue: 'Check'
  });

  const handleCredAdd = async () => {
    try {
      await env.http
        .post('credentials/add', {
          login: (credData.login !== '') ? credData.login : null,
          password: (credData.password !== '') ? credData.password : null,
          title: (credData.title !== '') ? credData.title : null,
          proxy_id: (credData.proxy_id !== '') ? credData.proxy_id : null,
          status: (credData.status !== '') ? credData.status : 'active'
        })
        .then(response => response.data);
      setCredData({
        ...credData,
        login: '',
        password: '',
        title: '',
        proxy_id: '',
        status: 'active'
      });
      onRequestClose();
      env.alert('Успех', `Данные успешно сохранены`);

    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleCredUpdate = async () => {
    try {
      await env.http
        .patch(`credentials`, {
          id: (credData.id !== '') ? credData.id : null,
          login: (credData.login !== '') ? credData.login : null,
          password: (credData.password !== '') ? credData.password : null,
          title: (credData.title !== '') ? credData.title : null,
          proxy_id: (credData.proxy_id !== '') ? credData.proxy_id : null,
          status: (credData.status !== '') ? credData.status : 'active',
        })
        .then(response => response.data);
      setCredData({
        ...credData,
        login: '',
        password: '',
        title: '',
        proxy_id: '',
        status: 'active'
      });
      onRequestClose();
      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleCredFetch = async (credId) => {
    try {
      const data = await env.http
        .get(`credentials/${credId}`)
        .then(response => response.data);
      setCredData(
        {
          ...credData,
          id: data.id,
          login: data.login,
          password: data.password,
          title: data.title,
          proxy_id: data.proxy_id,
          status: data.status || 'active'
        }
      );
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не получены.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleCredLoginCheck = async (credId) => {
    setCredData({
      ...credData,
      checkButtonValue: 'Checking...'
    });
    try {
      const data = await env.http
        .get(`credentials/test/${credId}`)
        .then(response => response.data);

      setCredData(
        {
          ...credData,
          checkStatus: true,
          proxyStatus: data.proxy,
          authStatus: data.auth
        }
      );

    } catch (e) {

      setCredData({
        ...credData,
        checkStatus: false,
        proxyStatus: false,
        authStatus: false,
        checkButtonValue: 'Check'
      });
      
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не удалось проверить.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }

  };

  const handleCancelButton = () => {
    setCredData({
      ...credData,
      login: '',
      password: '',
      title: '',
      proxy_id: '',
      status: 'active'
    });
    onRequestClose();
  };
  const handleSaveButton = () => {
    if (selectedCredId) {
      handleCredUpdate();
    } else {
      handleCredAdd();
    }
  };

  useEffect(() => {
    if (selectedCredId && isOpen) {
      handleCredFetch(selectedCredId);
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
          width: '50%',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }}>

      <div style={{ textAlign: 'center', width: '100%' }}>
        <h2>{selectedCredId ? 'Обновить креды' : 'Добавить новые креды'}</h2>
      </div>
      <div
        className='account-search-fields'
        style={{
          margin: '50px',
          maxHeight: '150px',
          fontSize: 'medium'
        }}>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '50%', marginRight: '10px' }}>
            <h3>Login</h3>
            <input
              className='main-form__input main-form__input-full'
              value={credData.login}
              onChange={e => {
                setCredData({ ...credData, login: e.target.value });
              }}
            />
          </div>
          <div style={{ width: '50%' }}>
            <h3>Password</h3>
            <input
              className='main-form__input main-form__input-full'
              value={credData.password}
              onChange={e => {
                setCredData({ ...credData, password: e.target.value });
              }}
            />
          </div>
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '50%', marginRight: '10px' }}>
            <h3>Title</h3>
            <input
              className='main-form__input main-form__input-full'
              value={credData.title}
              onChange={e => {
                setCredData({ ...credData, title: e.target.value });
              }}
            />
          </div>
          <div style={{ width: '50%' }}>
            <h3>Proxy</h3>
            <div>
              <PrefetchSelect
                optionalStyle={{
                  height: "48px",
                  borderRadius: "6px",
                  border: "1px solid rgba(137, 132, 146, 0.5)",
                  backgroundColor: "#fff",
                  color: "#898492",
                  fontFamily: "'Exo 2', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                  fontWeight: "500",
                  fontSize: "14px",
                  lineheight: "28px",
                }}
                editMode={true}
                type={`proxies/?cred_id=${selectedCredId}`}
                current={credData.proxy_id}
                onChange={value => (credData.proxy_id = value ? value : null)}
              />
            </div>
          </div>
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '50%', marginRight: '10px' }}>
            <h3>Status</h3>
            <Select
              style={{
                height: "48px",
                borderRadius: "6px",
                border: "1px solid rgba(137, 132, 146, 0.5)",
                backgroundColor: "#fff",
                color: "#898492",
                fontFamily: "'Exo 2', 'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "500",
                fontSize: "14px",
                lineheight: "28px",
              }}
              searchable={false}
              name='status'
              value={credData.status}
              onChange={(event) => setCredData({ ...credData, status: event.value })}
              options={[
                { value: 'active', label: 'active' },
                { value: 'inactive', label: 'inactive' },
                { value: 'blocked', label: 'blocked' },
              ]}
              clearable={false}
            />
          </div>

          <div style={{ width: '50%' }}>
            <h3>Check</h3>
            <div style={{width: '100%', padding: '5px', textAlign: 'center'}}>
              <button
                style={{minWidth: '100px'}}
                type='button'
                className='filter-columns__save'
                onClick={() => handleCredLoginCheck(credData.id)}
              >
                {credData.checkButtonValue}
              </button>
              {credData.checkStatus &&
                <>
                  <h3>Proxy status: 
                    <span style={{color: credData.proxyStatus ? 'green' : 'red', marginLeft: "10px", fontSize: "16px"}}>
                      {credData.proxyStatus ? 'OK' : 'FAIL'}
                      </span>
                      </h3>
                  <h3>Auth status: 
                    <span style={{color: credData.authStatus ? 'green' : 'red', marginLeft: "10px", fontSize: "16px"}}>
                      {credData.authStatus ? 'OK' : 'FAIL'}
                      </span>
                      </h3>
                </>
              }
            </div>
            </div>
          </div>

        </div>
        <button
          type='button'
          className='filter-columns__save'
          style={{
            position: 'absolute',
            bottom: '0',
            height: '34px',
            color: 'red',
            background: '#fff',
            width: '40%',
            left: 0,
            margin: '20px',
            border: 'none'
          }}
          onClick={handleCancelButton}
        >
          Отмена
        </button>

        <button
          type='button'
          className='filter-columns__save'
          style={{
            position: 'absolute',
            bottom: '0',
            height: '34px',
            color: '#fff',
            background: '#161021',
            width: '50%',
            right: 0,
            margin: '20px',
            borderRadius: '6px'
          }}
          onClick={handleSaveButton}
        >
          Сохранить
        </button>
    </Modal>
  );
};

export default CredModal;
